import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Components & Assets
import logo from '../../../assets/images/Icon.svg';

// MUI Components
import {
  Container,
  Paper,
  Button,
  TextField,
  Box,
  Typography,
} from '@mui/material';

// Utils
import NProgress from '../../../utils/nprogress';
import { showSuccessToast, showErrorToast } from '../../../utils/toastUtils';

// Skeleton for loading
import { Skeleton } from '@mui/material';

const Register = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // شبیه‌سازی لودینگ
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  // مدیریت ثبت‌نام
  const handleRegister = async () => {
  const name = document.querySelector("[name='name']")?.value || '';
  const lastName = document.querySelector("[name='lastName']")?.value || '';
  const phoneNumber = document.querySelector("[name='phoneNumber']")?.value || '';
  const email = document.querySelector("[name='email']")?.value || '';
  const username = document.querySelector("[name='username']")?.value || '';
  const password = document.querySelector("[name='password']")?.value || '';
  const rePassword = document.querySelector("[name='re-password']")?.value || '';

  if (!name || !lastName || !phoneNumber || !email || !username || !password || !rePassword) {
    showErrorToast("⚠️ لطفا تمام فیلدها رو پر کنید");
    return;
  }

  if (password !== rePassword) {
    showErrorToast("⚠️ رمز عبور با تکرارش مطابقت ندارد");
    return;
  }

  try {
    const res = await fetch('/db/register.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, lastName, phoneNumber, email, username, password, rePassword }),
    });

    const text = await res.text();
    
    let result;
    try {
      result = JSON.parse(text.replace(/^\s+|\s+$/g, '')); // ✅ حذف فضای خالی بالا/پایین
    } catch (parseError) {
      console.error("❌ خروجی سرور:", text);
      showErrorToast("❌ خروجی سرور JSON نیست");
      return;
    }

    if (result.status === 'success') {
      showSuccessToast("✅ " + result.message);
      setTimeout(() => navigate('/auth/login'), 1000);
    } else {
      showErrorToast("❌ " + result.message);
    }
  } catch (err) {
    console.error("🚫 خطای شبکه:", err);
    showErrorToast("🚫 خطایی در برقراری ارتباط رخ داد");
  }
};

  // مدیریت تغییر به ورود
  const goToLogin = () => {
    NProgress.start();
    navigate('/auth/login');
    setTimeout(() => NProgress.done(), 300);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'var(--color-bg)',
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={3} className="register-card">
          <Box sx={{ p: 3, textAlign: 'center' }}>
            {/* لوگو */}
            <Box sx={{ mb: 3 }}>
              <img src={logo} alt="لوگو" style={{ width: 50, height: 50 }} />
            </Box>

            {/* Skeleton در حالت لودینگ */}
            {loading ? (
              <Box sx={{ mt: 2 }}>
                <Skeleton variant="rectangular" height={65} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" height={65} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" height={65} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" height={65} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" height={65} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" height={65} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" height={65} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" height={48} />
              </Box>
            ) : (
              <>
                <TextField name="name" label="نام" fullWidth margin="normal" />
                <TextField name="lastName" label="نام خانوادگی" fullWidth margin="normal" />
                <TextField name="phoneNumber" label="شماره تماس" type="tel" fullWidth margin="normal" />
                <TextField name="email" label="ایمیل" type="email" fullWidth margin="normal" />
                <TextField name="username" label="نام کاربری" fullWidth margin="normal" />
                <TextField name="password" label="رمز عبور" type="password" fullWidth margin="normal" />
                <TextField name="re-password" label="تکرار رمز عبور" type="password" fullWidth margin="normal" />
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{ mt: 2 }}
                  onClick={handleRegister}
                >
                  ثبت‌نام
                </Button>
              </>
            )}

            {/* دکمه تعویض فرم */}
            <Box sx={{ mt: 2 }}>
              <Typography
                variant="body2"
                component="p"
                onClick={goToLogin}
                sx={{
                  color: 'var(--color-primary)',
                  cursor: 'pointer',
                }}
              >
                قبلاً ثبت نام کرده‌اید؟ ورود به حساب
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Register;